export default {
    monthly: 'Monthly',
    exportPDF: 'Export PDF',
    exportExcel: 'Export Excel',
    selectAll: 'Select All'
}
